// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"706":"3830779d3b2dcad9","3204":"e9fefbfc274a68fb","3760":"e93300430df1ef32","8098":"c36ce1f4b3e94fa9","9464":"fa5b00ebbe441f89"}[chunkId] + ".css";
};